<section
  class="chips-container-wrapper"
  *ngIf="viewModel$ | async as viewModel"
>
  <div class="chips-container" *ngIf="viewModel.jobLoaded; else loading">
    {{ viewModel.jobFromParams?.code }}
    <app-overview-chip
      icon="pi-calendar"
      [value]="
        viewModel.job?.createdAt
          ? (viewModel.job?.createdAt | freyaDate)
          : 'N/A'
      "
      label="Created at"
    ></app-overview-chip>
    <app-overview-chip
      icon="pi-dollar"
      [value]="
        viewModel.job.total
          ? (viewModel.job.total | freyaCurrency: viewModel.job.currency)
          : 'N/A'
      "
      label="Revenue"
    ></app-overview-chip>
    <app-job-agent
      class="agentChip"
      [role]="roles.salesAgentRole"
    ></app-job-agent>
    <app-job-agent
      class="agentChip"
      [role]="roles.estimatorRole"
    ></app-job-agent>
  </div>
</section>

<ng-template #loading>
  <p-skeleton
    class="flex-1"
    borderRadius="2.1875rem"
    *ngFor="let _ of [1, 2, 3, 4]"
    width="100%"
    height="4rem"
  />
</ng-template>
